import Dialog, {DialogProps, DialogTheme} from '@luminopia/react-toolbox/lib/dialog'
import {composeTheme} from 'core/utils/theme-helpers'
import * as styles from './scroll-dialog.css'

export const ScrollDialog = composeTheme<DialogProps, {}, DialogTheme>(Dialog, styles)



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/components/dialog/scroll-dialog.tsx